import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { toast } from "react-toastify";

import Header from '../../Header';
import Sidebar from '../../Sidebar';
import Footer from '../../Footer';
import Spinner from '../../common/Spinner';
import LazyCKEditor from '../../common/LazyCKEditor';
import { addBuild, getLatestBuild } from '../../../redux/actions/BuildActions';
import { UserDropdown } from '../../../redux/actions/userActions';
import { editApp } from '../../../redux/actions/AppActions';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AddBuild = ({match}) => {
    const appId = match.params.id;
    const history = useHistory();
	const dispatch = useDispatch();
	const appEdit = useSelector((state) => state.appEdit);
	const users = useSelector((state) => state.userDropdown.users);
    const [submitted, setSubmitted] = useState(false);  
	const [osSelect, setOsSelect] = useState(false); 
    const [uploadedFile, setUploadedFile] = useState(null)
	const [fileType, setFileType ] = useState('.ipa');
	const [loading, setLoading] = useState(false); 
	const [selectedUserIds, setSelectedUserIds] = useState([]);
	const [selectedClientIds, setSelectedClientIds] = useState([]);
	const [formState,setFormState] = useState({
        values:{
			os: 'iOS',
			version:'',
			notes:''
		},
		errors: {}       
    });
	const [fileError, setFileError] = useState('');
	const [envirionment, setEnvirionment] = useState('Production');
	// Visibility: "Private" (default) limits /install-meta + /manifest.plist
	// to org members; "Public" lets anyone with the /install/:appId/:buildId
	// URL install the build (Diawi-style shareable link).
	const [isPublic, setIsPublic] = useState(false);
	const organization = useSelector((state)=>state?.organizationDetails?.organization);
	const organizationId = organization?.organization_id;
console.log("IN ADD BUILD component")
	const { app } = appEdit;

	useEffect(() => {
		if (!app.name || app.id !== Number(appId)) {
		  dispatch(editApp(appId));        
		} else {
			if(app.isAndriod === 1 && app.isIos === 1){
              setOsSelect(true);
			  setBuildVersion(appId, 'iOS', envirionment)
			} else if(app.isAndriod === 1){
				setFormState({
					values: {
						os: 'Android',
						version: '',
						notes: ''
					},
					errors: {
						...formState.errors
					}    
				})
				setFileType('.apk')
				setBuildVersion(appId, 'Android', envirionment)
			} else if(app.isIos === 1){
				setFormState({
					values: {
						os: 'iOS',
						version: '',
						notes: ''
					},
					errors: {
						...formState.errors
					}    
				})
				setFileType('.ipa')
				setBuildVersion(appId, 'iOS', envirionment)
			}
		}
	}, [app, dispatch, appId]);

	useEffect(() => {
    	dispatch(UserDropdown('build', appId, organizationId));
  	}, [organizationId]);

	const handleUserChange = (event) => {
	  const selectedUserId = parseInt(event.target.value);
	  if (!selectedUserIds.includes(selectedUserId)) {
		setSelectedUserIds([...selectedUserIds, selectedUserId]);
	  }
	};

	const handleClientChange = (event) => {
		const selectedClientId = parseInt(event.target.value);
		if (!selectedClientIds.includes(selectedClientId)) {
		  setSelectedClientIds([...selectedClientIds, selectedClientId]);
		}
	  };
  
	const removeUser = (userIdToRemove) => {
	  setSelectedUserIds(selectedUserIds.filter(userId => userId !== userIdToRemove));
	};

	const removeClient = (clientIdToRemove) => {
		setSelectedClientIds(selectedClientIds.filter(clientId => clientId !== clientIdToRemove));
	};
  
	const filteredOptions = users.filter(option => !selectedUserIds.includes(option.id) && option.role !== 'Client');
	const selectedUsers = users.filter(option => selectedUserIds.includes(option.id) && option.role !== 'Client');
    const members = users.filter(option => option.role !== 'Client');

	const filteredClientOptions = users.filter(option => !selectedClientIds.includes(option.id) && option.role === 'Client');
    const selectedClients = users.filter(option => selectedClientIds.includes(option.id) && option.role === 'Client');
    const clients = users.filter(option => option.role === 'Client');
	
    const handleChange = (event) => {
        setFormState(formState =>({
          ...formState,
          values:{
            ...formState.values,
            [event.target.name]:
            event.target.type === 'checkbox'
                ? event.target.checked
                : event.target.value
          },
		  errors: {
			...formState.errors,
			[event.target.name]: getValidationError(event.target.name, event.target.value)
		  }
        }));
    }

	const getValidationError = (name, value) => {
		switch (name) {
		  case 'version':
			return validateVersion(value);
		  default:
			return '';
		}
	};

	const validateVersion = (version) => {
		if(envirionment === 'Staging'){
			const versionPattern = /^(\d+)\.(\d+)\.(\d+)$/;
			const match = version.match(versionPattern);

			if (!match) {
				return 'Version must be in the format x.x.x (e.g. 1.0.0, 0.1.0)';
			}

			const [major, minor, patch] = match.slice(1).map(num => (num !== undefined ? Number(num) : 0));
			if (major < 0 || minor < 0 || patch < 1) {
				return 'For staging, version must be 0.0.1';
			}

		} else if(envirionment === 'Production'){
			const versionPattern = /^(\d+)\.(\d+)$/;
			const match = version.match(versionPattern);

			if (!match) {
				return 'Version must be in the format x.x  (e.g., 1.0, 1.1)';
			}

			const [major, minor, patch] = match.slice(1).map(num => (num !== undefined ? Number(num) : 0));
			if (major < 1 || (major === 1 && minor < 0) || patch >=0) {
				return 'For production, version must be 1.0 or higher';
			}
		}
	  };
	  

    const handleUploadChange = (event) => {
        event.preventDefault();
		const file = event.target.files[0];
		
		if (file && !file.name.endsWith(fileType)) {
			setFileError(`Invalid file type. Please upload a ${fileType} file.`);
			setUploadedFile(null);
		  } else {
			setFileError('');
			setUploadedFile(file);
		  }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true); 
        const { os, version, notes } = formState.values;
        let payload = new FormData();

        payload.set("version", version);
        payload.set("notes", notes);
		payload.set("os", os);
        payload.append("file", uploadedFile);
		payload.set("selectedUserIds", selectedUserIds);
		payload.set("selectedClientIds", selectedClientIds);
		payload.set("envirionment", envirionment)
		payload.set("isPublic", isPublic ? 'true' : 'false')
console.log(formState)
      if (os && notes && version && uploadedFile) {
		if (!formState?.errors?.version && formState?.values?.version) {
			if(envirionment.length > 0){
				setLoading(true)
				dispatch(addBuild(appId, payload)).then((response)=>{
					if(response === 'success'){
						setFormState({
							values: {
								os: '',
								version: '',
								notes: ''
							},
							errors: {}
						})
						setSubmitted(false);
						setUploadedFile(null)
						navigateToBuildList();
					} else {
						setLoading(false)
					}
				});
			} else {
				toast.error("Please select an environment")
			}
		} else {
           toast.error(formState.errors.version)
		}
       } else {
		if(fileError){
			toast.error(fileError)
		} else {
           toast.error("Please fill in all the details")
		}
	   }
    }

	const navigateToBuildList = () => {
		history.push(`/app/${appId}/builds`);
	};

	const handleOs = (e) => {
		if(e.target.value === 'Android'){
			setFileType('.apk')
			setBuildVersion(appId, 'Android', envirionment)
		} else if(e.target.value === 'iOS'){
			setBuildVersion(appId, 'iOS', envirionment)
			setFileType('.ipa')
		} else {
			setFileType('')
		}

		setUploadedFile(null)
		setFileError('')
		setFormState(formState =>({
			...formState,
			values:{
			  ...formState.values,
			  'os' : e.target.value
			},
			errors: {
				...formState.errors
			}    
		}));
	}

	const handleEditorChange = (event, editor) => {
		const data = editor.getData();
		setFormState({
			...formState,
			values: {
				...formState.values,
				notes: data,
			},
			errors: {
				...formState.errors
			} 
		});
	};

	const handleEnvirionment = (e) => {
		setEnvirionment(e.target.value);
		setBuildVersion(appId, formState?.values?.os, e.target.value)
	}

	const setBuildVersion = (appId, os, envirionment) => {
		dispatch(getLatestBuild(appId, os, envirionment)).then((response)=>{
			if(response){
				const versionParts = response?.data.split('.').map(Number);
				if(envirionment === 'Staging'){
					versionParts[2] += 1;
					setFormState(formState =>({
						...formState,
						values:{
						  ...formState.values,
						  version: versionParts.join('.')
						},
						errors: {
							...formState.errors
						} 
					}));
				} else {
					versionParts[1] += 1;
					setFormState(formState =>({
						...formState,
						values:{
						  ...formState.values,
						  version: versionParts.join('.')
						},
						errors: {
							...formState.errors
						} 
					}));
				}
			} else {
				setFormState(formState =>({
					...formState,
					values:{
					  ...formState.values,
					  version: envirionment === 'Staging' ? '1.0.0' : '1.0'
					},
					errors: {
						...formState.errors
					} 
				}));
			}
		});
	}

	const showIosRadio = osSelect === true || formState.values.os === 'iOS';
	const showAndroidRadio = osSelect === true || formState.values.os === 'Android';

	return (
		<>
			<div className="container-scroller">
				<Header />
				<div className="container-fluid page-body-wrapper">
					<Sidebar />
					<Box component="main" className="main-panel" sx={{ display: "flex", flexDirection: "column" }}>
						<Box sx={{ flex: 1, py: { xs: 2, md: 3 } }}>
							<Container maxWidth="lg" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
								<Paper elevation={0} sx={{ p: { xs: 2, md: 4 }, border: "1px solid", borderColor: "divider" }}>
									<Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
										<IconButton component={RouterLink} to={`/app/${app?.id}/builds`} size="small" aria-label="Back">
											<ArrowBackIcon />
										</IconButton>
										<Typography variant="h3" component="h1">
											New build
										</Typography>
										{app?.name && (
											<Typography variant="body2" sx={{ color: "text.secondary", ml: 1 }}>
												· {app.name}
											</Typography>
										)}
									</Stack>

									<form onSubmit={handleSubmit} noValidate>
										<Stack spacing={3}>
											<FormControl>
												<FormLabel sx={{ fontWeight: 700, color: "text.primary", mb: 0.5 }}>
													OS <Box component="span" sx={{ color: "error.main" }}>*</Box>
												</FormLabel>
												<RadioGroup row value={formState.values.os || ""} onChange={handleOs} name="os">
													{showIosRadio && (
														<FormControlLabel
															value="iOS"
															control={<Radio />}
															label={
																<Stack direction="row" spacing={0.75} alignItems="center">
																	<AppleIcon fontSize="small" />
																	<span>iOS</span>
																</Stack>
															}
															sx={{ mr: 4 }}
														/>
													)}
													{showAndroidRadio && (
														<FormControlLabel
															value="Android"
															control={<Radio />}
															label={
																<Stack direction="row" spacing={0.75} alignItems="center">
																	<AndroidIcon fontSize="small" />
																	<span>Android</span>
																</Stack>
															}
														/>
													)}
												</RadioGroup>
											</FormControl>

											<Stack direction={{ xs: "column", md: "row" }} spacing={3}>
												<FormControl fullWidth required>
													<InputLabel id="env-label">Environment</InputLabel>
													<Select
														labelId="env-label"
														label="Environment"
														value={envirionment}
														onChange={handleEnvirionment}
													>
														<MenuItem value="Production">Production</MenuItem>
														<MenuItem value="Staging">Staging</MenuItem>
													</Select>
												</FormControl>

												<FormControl fullWidth required>
													<InputLabel id="visibility-label">Visibility</InputLabel>
													<Select
														labelId="visibility-label"
														label="Visibility"
														value={isPublic ? "public" : "private"}
														onChange={(e) => setIsPublic(e.target.value === "public")}
													>
														<MenuItem value="private">Private — org members only</MenuItem>
														<MenuItem value="public">Public — anyone with the install link</MenuItem>
													</Select>
													<FormHelperText>
														Public builds can be installed by anyone holding the URL.
													</FormHelperText>
												</FormControl>
											</Stack>

											<TextField
												label="Build version"
												name="version"
												required
												fullWidth
												value={formState.values.version || ""}
												onChange={handleChange}
												error={Boolean((submitted && !formState.values.version) || formState.errors.version)}
												helperText={
													(submitted && !formState.values.version && "Version is required") ||
													formState.errors.version ||
													(envirionment === "Staging" ? "Format: x.x.x (e.g. 0.1.0)" : "Format: x.x (e.g. 1.0)")
												}
											/>

											<Box>
												<Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
													Release notes <Box component="span" sx={{ color: "error.main" }}>*</Box>
												</Typography>
												<style>{`.ck-editor__editable_inline { min-height: 200px; }`}</style>
												<LazyCKEditor
													data={formState.values.notes || ""}
													onChange={handleEditorChange}
												/>
												{submitted && !formState.values.notes && (
													<FormHelperText error>Release notes are required</FormHelperText>
												)}
											</Box>

											{formState.values.os?.length > 0 && (
												<Box>
													<Button
														component="label"
														variant="outlined"
														fullWidth
														startIcon={<UploadFileIcon />}
														sx={{
															height: 56,
															borderColor: submitted && !uploadedFile ? "error.main" : "divider",
															color: "text.secondary",
															justifyContent: "flex-start",
															textTransform: "none",
														}}
													>
														{uploadedFile ? uploadedFile.name : `Upload ${fileType} file *`}
														<input
															type="file"
															name="file"
															accept={fileType}
															hidden
															onChange={handleUploadChange}
														/>
													</Button>
													{fileError && <FormHelperText error>{fileError}</FormHelperText>}
													{submitted && !uploadedFile && !fileError && (
														<FormHelperText error>File is required</FormHelperText>
													)}
												</Box>
											)}

											<Divider sx={{ my: 1 }} />

											<Box>
												<Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
													Email build notification to
												</Typography>
												{members.length > 0 ? (
													<FormControl fullWidth>
														<Select
															value=""
															displayEmpty
															onChange={handleUserChange}
															renderValue={() =>
																selectedUsers.length ? (
																	<Stack direction="row" spacing={0.75} useFlexGap sx={{ flexWrap: "wrap" }}>
																		{selectedUsers.map((user) => (
																			<Chip
																				key={user.id}
																				label={user.name}
																				size="small"
																				onDelete={() => removeUser(user.id)}
																				sx={{ bgcolor: "primary.main", color: "secondary.dark", fontWeight: 600 }}
																			/>
																		))}
																	</Stack>
																) : <Box sx={{ color: "text.secondary" }}>Select members to notify</Box>
															}
														>
															<MenuItem value="" disabled>Select user</MenuItem>
															{filteredOptions.map((user) => (
																<MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>
															))}
														</Select>
													</FormControl>
												) : (
													<Typography variant="body2" sx={{ color: "text.secondary" }}>
														Ask an admin to add members to {app?.name} before notifying them of new builds.
													</Typography>
												)}
											</Box>

											<Box>
												<Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
													Client access
												</Typography>
												{clients.length > 0 ? (
													<FormControl fullWidth>
														<Select
															value=""
															displayEmpty
															onChange={handleClientChange}
															renderValue={() =>
																selectedClients.length ? (
																	<Stack direction="row" spacing={0.75} useFlexGap sx={{ flexWrap: "wrap" }}>
																		{selectedClients.map((user) => (
																			<Chip
																				key={user.id}
																				label={user.name}
																				size="small"
																				onDelete={() => removeClient(user.id)}
																				sx={{ bgcolor: "primary.main", color: "secondary.dark", fontWeight: 600 }}
																			/>
																		))}
																	</Stack>
																) : <Box sx={{ color: "text.secondary" }}>Select clients to grant access</Box>
															}
														>
															<MenuItem value="" disabled>Select client</MenuItem>
															{filteredClientOptions.map((user) => (
																<MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>
															))}
														</Select>
													</FormControl>
												) : (
													<Typography variant="body2" sx={{ color: "text.secondary" }}>
														No client users found on {app?.name}. Ask an admin to add one.
													</Typography>
												)}
											</Box>

											<Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ pt: 1 }}>
												<Button type="submit" variant="contained" size="large" sx={{ minWidth: 160 }}>
													Upload build
												</Button>
												<Button component={RouterLink} to={`/app/${appId}/builds`} variant="outlined" size="large" sx={{ minWidth: 140 }}>
													Cancel
												</Button>
											</Stack>
										</Stack>
									</form>
								</Paper>
							</Container>
						</Box>
						<Footer />
					</Box>
				</div>
			</div>
			{loading && <Spinner fullscreen label="Uploading…" />}
		</>
	);
}

export default AddBuild;